import React from "react";

import styled from "@emotion/styled";

import CategoryTree from "./CategoryTree";
import Search from "./Search";

export const Wrapper = styled.div`
    width: 100%;
    min-width: 240px;
    margin-bottom: 20px;
`;

export const Container = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 10px;

    ${({ theme }) => theme.breakpoints.from.medium.css`
       position: sticky;
       top: 120px;
       margin-bottom: 0;
    `}
    ${({ theme }) => theme.breakpoints.from.extraLarge.css`
            top: 160px;
    `}
`;

const TreeWrapper = styled.div`
    max-height: 65vh;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
`;

const SideNavigation = () => {
    return (
        <Wrapper>
            <Container>
                <Search />
                <TreeWrapper>
                    <CategoryTree />
                </TreeWrapper>
            </Container>
        </Wrapper>
    );
};

export default SideNavigation;
